module.exports = __webpack_public_path__ + "img/backBtn.df446772.png";